import  './../css/GRecentJobs.css';
import  './../css/GBrowsebycategory.css';
import  './../css/GSideBar.css';
import  './../css/GPostJob.css';
import  './../css/GMediaQuery.css';
import  './../css/Gtop.css';
import  './../css/GAnimetion.css';
import  './../css/GGraphicJob.css';
import  './../css/GFooter.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {systemConfiguration} from '../../../src/CommonImports';

function GRecentJobs(){
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
return (
<section className="section-box mt-5">
  <div className="container">
    <div className="row align-items-end mb-4">
      <div className="col-lg-4">
        <h2 className="section-title mb-2">Recent Jobs</h2>
        <p className="fw-bold">9 new opportunities posted today!</p>
      </div>
      <div className="col-lg-8 text-lg-end text-start">
        <ul className="nav nav-pills justify-content-lg-end mb-3" id="jobPills" role="tablist">
          <li className="nav-item" role="presentation"><button className="nav-link active" data-bs-toggle="pill" data-bs-target="#Gdesign" type="button">Design</button></li>
          <li className="nav-item" role="presentation"><button className="nav-link" data-bs-toggle="pill" data-bs-target="#Gdesign" type="button">Marketing</button></li>
          <li className="nav-item" role="presentation"><button className="nav-link" data-bs-toggle="pill" data-bs-target="#Gdesign" type="button">Service</button></li>
          <li className="nav-item" role="presentation"><button className="nav-link" data-bs-toggle="pill" data-bs-target="#Gdesign" type="button">Health Care</button></li>
          <li className="nav-item" role="presentation"><button className="nav-link" data-bs-toggle="pill" data-bs-target="#Gdesign" type="button">Writing</button></li>
        </ul>
      </div>
    </div>

 <div className="tab-content mt-4" id="jobPillsContent">
  <div className="tab-pane fade show active" id="Gdesign">
    <div className="row g-4">
      <div className="col-lg-4 col-md-6">
        <div className="card-grid-2 hover-up h-100">
          <div className="card-grid-2-image">
            <a href="#"><img src={mediaUrl+"job-1.png?"+sasToken} alt="Job Image"/></a>
            <label className="btn-urgent">Urgent</label>
          </div>
          <div className="card-block-info">
            <div>
              <div className="row align-items-center mb-2">
                <div className="col-7">
                  <a href="#" className="text-decoration-none text-dark">
                    <span className="card-grid-2-img-small"><img src={mediaUrl+"logo-1.svg?"+sasToken} alt="Logo"/></span>
                    <span>Alithemes</span>
                  </a>
                </div>
                <div className="col-5 text-end">
                  <a href="#" className="btn btn-outline-secondary btn-sm disc-btn">Fulltime</a>
                </div>
              </div>
              <h5 className="mt-2"><a href="#" className="text-decoration-none text-dark">Full Stack Developer</a></h5>
              <div className="mt-2">
                <span className="card-time">3 mins ago</span>
                <span className="card-location">Chicago</span>
              </div>
            </div>
            <div className="card-2-bottom mt-3">
              <div className="row align-items-center">
                <div className="col-8">
                  <span className="card-text-price">$3200<span>/Month</span></span>
                </div>
                <div className="col-4 text-end">
                  <img src={mediaUrl+"shield-check.svg?"+sasToken} alt="Verified" height="18"/>
                  <img src={mediaUrl+"bookmark.svg?"+sasToken} alt="Bookmark" height="18" className="ml-5"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-4 col-md-6">
        <div className="card-grid-2 hover-up h-100">
          <div className="card-grid-2-image">
            <a href="#"><img src={mediaUrl+"job-2.png?"+sasToken} alt="Job Image"/></a>
            <label className="btn-urgent">Urgent</label>
          </div>
          <div className="card-block-info">
            <div>
              <div className="row align-items-center mb-2">
                <div className="col-7">
                  <a href="#" className="text-decoration-none text-dark">
                    <span className="card-grid-2-img-small"><img src={mediaUrl+"logo-1.svg?"+sasToken}
                        alt="Logo"/></span><span>Alithemes</span></a>
                </div>
                <div className="col-5 text-end"><a href="#" className="btn btn-outline-secondary btn-sm disc-btn">Fulltime</a>
                </div>
              </div>
              <h5 className="mt-2"><a href="#" className="text-decoration-none text-dark">Facebook Banner Design</a>
              </h5>
              <div className="mt-2"><span className="card-time">3 mins ago</span>
                <span className="card-location">Chicago</span>
              </div>
            </div>
            <div className="card-2-bottom mt-3">
              <div className="row align-items-center">
                <div className="col-8">
                  <span className="card-text-price">$3200<span>/Month</span></span>
                </div>
                <div className="col-4 text-end">
                  <img src={mediaUrl+"shield-check.svg?"+sasToken} alt="Verified" height="18"/>
                  <img src={mediaUrl+"bookmark.svg?"+sasToken} alt="Bookmark" height="18" className="ml-5"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-4 col-md-6">
        <div className="card-grid-2 hover-up h-100">
          <div className="card-grid-2-image"><a href="#"><img src={mediaUrl+"job-3.png?"+sasToken} alt="Job Image"/></a><label
              className="btn-urgent">Urgent</label></div>
          <div className="card-block-info">
            <div>
              <div className="row align-items-center mb-2">
                <div className="col-7"><a href="#" className="text-decoration-none text-dark"><span
                      className="card-grid-2-img-small"><img src={mediaUrl+"logo-1.svg?"+sasToken}
                        alt="Logo"/></span><span>Alithemes</span></a></div>
                <div className="col-5 text-end"><a href="#" className="btn btn-outline-secondary btn-sm disc-btn">Fulltime</a>
                </div>
              </div>
              <h5 className="mt-2"><a href="#" className="text-decoration-none text-dark">Instagram Post Images</a></h5>
              <div className="mt-2"><span className="card-time">3 mins ago</span><span className="card-location">Chicago</span>
              </div>
            </div>
            <div className="card-2-bottom mt-3">
              <div className="row align-items-center">
                <div className="col-8"><span className="card-text-price">$3200<span>/Month</span></span></div>
                <div className="col-4 text-end"><img src={mediaUrl+"shield-check.svg?"+sasToken} alt="Verified" height="18"/><img
                    src={mediaUrl+"bookmark.svg?"+sasToken} alt="Bookmark" height="18" className="ml-5"/></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-4 col-md-6">
        <div className="card-grid-2 hover-up h-100">
          <div className="card-grid-2-image"><a href="#"><img src={mediaUrl+"job-4.png?"+sasToken} alt="Job Image"/></a><label
              className="btn-urgent">Urgent</label></div>
          <div className="card-block-info">
            <div>
              <div className="row align-items-center mb-2">
                <div className="col-7"><a href="#" className="text-decoration-none text-dark"><span
                      className="card-grid-2-img-small"><img src={mediaUrl+"logo-1.svg?"+sasToken}
                        alt="Logo"/></span><span>Alithemes</span></a></div>
                <div className="col-5 text-end"><a href="#" className="btn btn-outline-secondary btn-sm disc-btn">Fulltime</a>
                </div>
              </div>
              <h5 className="mt-2"><a href="#" className="text-decoration-none text-dark">Logo & Branding Design</a></h5>
              <div className="mt-2"><span className="card-time">3 mins ago</span><span className="card-location">Chicago</span>
              </div>
            </div>
            <div className="card-2-bottom mt-3">
              <div className="row align-items-center">
                <div className="col-8"><span className="card-text-price">$3200<span>/Month</span></span></div>
                <div className="col-4 text-end"><img src={mediaUrl+"shield-check.svg?"+sasToken} alt="Verified" height="18"/><img
                    src={mediaUrl+"bookmark.svg?"+sasToken} alt="Bookmark" height="18" className="ml-5"/></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-4 col-md-6">
        <div className="card-grid-2 hover-up h-100">
          <div className="card-grid-2-image"><a href="#"><img src={mediaUrl+"job-5.png?"+sasToken} alt="Job Image"/></a><label
              className="btn-urgent">Urgent</label></div>
          <div className="card-block-info">
            <div>
              <div className="row align-items-center mb-2">
                <div className="col-7"><a href="#" className="text-decoration-none text-dark"><span
                      className="card-grid-2-img-small"><img src={mediaUrl+"logo-1.svg?"+sasToken}
                        alt="Logo"/></span><span>Alithemes</span></a></div>
                <div className="col-5 text-end"><a href="#" className="btn btn-outline-secondary btn-sm disc-btn">Fulltime</a>
                </div>
              </div>
              <h5 className="mt-2"><a href="#" className="text-decoration-none text-dark">UI/UX Web Designer</a></h5>
              <div className="mt-2"><span className="card-time">3 mins ago</span><span className="card-location">Chicago</span>
              </div>
            </div>
            <div className="card-2-bottom mt-3">
              <div className="row align-items-center">
                <div className="col-8"><span className="card-text-price">$3200<span>/Month</span></span></div>
                <div className="col-4 text-end"><img src={mediaUrl+"shield-check.svg?"+sasToken} alt="Verified" height="18"/><img
                    src={mediaUrl+"bookmark.svg?"+sasToken} alt="Bookmark" height="18" className="ml-5"/></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-4 col-md-6">
        <div className="card-grid-2 hover-up h-100">
          <div className="card-grid-2-image"><a href="#"><img src={mediaUrl+"job-6.png?"+sasToken} alt="Job Image"/></a><label
              className="btn-urgent">Urgent</label></div>
          <div className="card-block-info">
            <div>
              <div className="row align-items-center mb-2">
                <div className="col-7"><a href="#" className="text-decoration-none text-dark"><span
                      className="card-grid-2-img-small"><img src={mediaUrl+"logo-1.svg?"+sasToken}
                        alt="Logo"/></span><span>Alithemes</span></a></div>
                <div className="col-5 text-end"><a href="#" className="btn btn-outline-secondary btn-sm disc-btn">Fulltime</a>
                </div>
              </div>
              <h5 className="mt-2"><a href="#" className="text-decoration-none text-dark">Motion Graphics Artist</a></h5>
              <div className="mt-2"><span className="card-time">3 mins ago</span><span className="card-location">Chicago</span>
              </div>
            </div>
            <div className="card-2-bottom mt-3">
              <div className="row align-items-center">
                <div className="col-8"><span className="card-text-price">$3200<span>/Month</span></span></div>
                <div className="col-4 text-end"><img src={mediaUrl+"shield-check.svg?"+sasToken} alt="Verified" height="18"/><img
                    src={mediaUrl+"bookmark.svg?"+sasToken} alt="Bookmark" height="18" className="ml-5"/></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
</div>
</section>

)

}
export default GRecentJobs;